<!--Компонент отображающий детальную информацию о пользователе(владение языками, контактную информацию)-->
<template>
  <v-container fluid class="pa-0">
    <v-card class="my-2 text-left" flat>
      <v-divider/>
      <LanguagesSection
        :edit="edit"
        :languages="getProfile.languages"
        @add="opened_form_language = true"
        @edit="(item) => selectItem(item, 'opened_form_language')"
        @delete="(item) => deleteItem(item, 'Language')"
      />
      <v-card-title class="bg-grey-lighten-3 text-center title dark-primary">
        Контактная информация
      </v-card-title>
      <v-row>
        <PhonesSection
          :edit="edit"
          :phones="getProfile.phones"
          @add="opened_form_phone = true"
          @edit="(item) => selectItem(item, 'opened_form_phone')"
          @delete="(item) => deleteItem(item, 'Phone')"
        />
        <EmailsSection
          :edit="edit"
          :emails="getProfile.emails"
          @add="opened_form_email = true"
          @edit="(item) => selectItem(item, 'email')"
          @delete="(item) => deleteItem(item, 'Email')"
        />
        <v-divider></v-divider>
        <AddressesSection
          :edit="edit"
          :addresses="getProfile.addresses"
          @add="opened_form_addresses = true"
          @edit="(item) => selectItem(item, 'opened_form_addresses')"
          @delete="(item) => deleteItem(item, 'Address')"
        />

      </v-row>
      <EditLanguage
        v-if="opened_form_language"
        v-model="opened_form_language"
        :select="select"
        @save="saveForm"
        @close="opened_form_language=false; this.select = null"
      ></EditLanguage>
      <EditEmail
        v-if="opened_form_email"
        v-model="opened_form_email"
        :select="select"
        @save="saveForm"
        @close="opened_form_email=false; this.select = null"
      ></EditEmail>
      <EditPhone
        v-if="opened_form_phone"
        v-model="opened_form_phone"
        :select="select"
        @save="saveForm"
        @close="opened_form_phone=false; this.select = null"
      ></EditPhone>
      <EditAddress
        v-if="opened_form_addresses"
        v-model="opened_form_addresses"
        :select="select"
        @save="saveForm"
        @close="opened_form_addresses=false; this.select = null"
      ></EditAddress>
      <apply-dialog
        v-if="dialog_delete"
        v-model="dialog_delete"
        :get-text="() => `Вы уверены, что хотите удалить?`"
        @close="closeDeleteDialog"
      ></apply-dialog>
    </v-card>
  </v-container>

</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import EditEmail from '@/modules/profile/account/modals/edit/EditEmail'
import EditLanguage from '@/modules/profile/account/modals/edit/EditLanguage'
import EditPhone from '@/modules/profile/account/modals/edit/EditPhone'
import EditAddress from '@/modules/profile/account/modals/edit/EditAddress.vue'
import ApplyDialog from "@/modules/templates/ApplyDialog.vue"
import LanguagesSection from "@/modules/profile/account/components/LanguagesSection.vue";
import PhonesSection from "@/modules/profile/account/components/PhonesSection.vue";
import EmailsSection from "@/modules/profile/account/components/EmailsSection.vue";
import AddressesSection from "@/modules/profile/account/components/AddressesSection.vue";

export default {
  name: 'InformationUser',
  props: {
    edit: {
      type: Boolean,
      default: false
    }
  },
  components: {
    AddressesSection,
    EmailsSection,
    PhonesSection,
    LanguagesSection,
    EditLanguage,
    EditPhone,
    EditEmail,
    EditAddress,
    ApplyDialog
  },
  data () {
    return {
      opened_form_language: false,
      opened_form_email: false,
      opened_form_phone: false,
      opened_form_addresses: false,
      dialog_delete: false,
      select: null,
      delete_form: ''
    }
  },
  computed: {
    ...mapGetters({
      getProfile: 'user/getProfile'
    })
  },
  methods: {
    ...mapActions({
      deleteUserLanguage: 'user/deleteUserLanguage',
      deleteUserEmail: 'user/deleteUserMail',
      deleteUserPhone: 'user/deleteUserPhone',
      deleteUserAddress: 'user/deleteUserAddress'
    }),
    /**
     * Метод обрабатывает закрытие диалога подтверждения удаления
     * Выполняет удаление элемента при подтверждении или просто закрывает диалог при отмене
     * @param {Boolean} event - Флаг подтверждения удаления (true - подтверждено, false - отмена)
     */
    closeDeleteDialog (event) {
      if (event) {
        if (this.select) {
          this['deleteUser' + this.delete_form]({
            id: this.select.id,
            finalizer: (data, url) => {
              this.dialog_delete = false
              this.saveForm()
            },
            catcher: () => {
              this.dialog_delete = false
            }
          })
        }
      } else {
        this.dialog_delete = false
        this.select = null
      }
    },
    /**
     * Метод сохраняет изменения профиля и закрывает все открытые формы редактирования
     * Сбрасывает состояние компонента и инициирует обновление профиля через событие
     */
    saveForm () {
      this.opened_form_language = false
      this.opened_form_email = false
      this.opened_form_phone = false
      this.opened_form_addresses = false
      this.select = null
      this.delete_form = null
      this.$emit('update_profile')
    },
    /**
     * Метод подготавливает элемент для редактирования
     * Открывает соответствующую форму редактирования и устанавливает выбранный элемент
     * @param {Object} item - Элемент контактной информации для редактирования
     * @param {String} form - Имя формы для открытия (например, 'opened_form_language')
     */
    selectItem (item, form) {
      this[form] = true
      this.select = item
    },
    /**
     * Метод инициирует процесс удаления элемента контактной информации
     * Открывает диалог подтверждения удаления и сохраняет данные для последующего удаления
     * @param {Object} item - Элемент контактной информации для удаления
     * @param {String} form - Тип элемента для удаления (например, 'Language', 'Email')
     */
    deleteItem (item, form) {
      this.dialog_delete = true
      this.delete_form = form
      this.select = item
    }
  }
}
</script>

<style scoped>

</style>
